import React, { useEffect, useState, useCallback, useMemo } from "react";
// import { useSelector } from 'react-redux';
import PropTypes from "prop-types";
import { isTablet, isMobile } from "react-device-detect";
import { API_GET } from "../../config/axiosConfig";
import VagonStreamIntraverse from "./VagonStreamIntraverse";
import { getFromSessionStorage } from "../../hooks/useSessionStorage";
import { UpdateRoomInviteUserData } from "../../api/RoomsController";
// import { RegisterUserWithLionGaming } from '../lionGaming/apiController';

const VanityURLRedirects = (props) => {
    const [redirectURL, setRedirectURL] = useState(null);
    // const email = useSelector((state) => state.user.email);
    const resolvedPathId = props.pathId || window.location.pathname.split("/").pop();
    const currentPath = window.location.href;

    const isRoomInvite = localStorage.getItem("inviteRoomId") || "";
    const inviteSettings = localStorage.getItem("inviteSettings") || "";

    const launchFlags = useMemo(
        () => ({
            "-userid": props.userId,
            "-authtoken": props.token || getFromSessionStorage("userToken"),
            "-api": process.env.REACT_APP_STREAM_API_ENV,
            "-disableVoiceChat": false,
            "-showdebugger": true,
            "-userdevicetype": isTablet || isMobile ? "mobile" : "desktop",
            "-avatarpreset": getFromSessionStorage("selectedAvatar") || props.finalAvatar,
            "-url": encodeURIComponent(currentPath),
            "-disablecameramouserotation": true,
        }),
        [props.userId, props.token, currentPath, props.finalAvatar]
    );

    const fetchVanityLink = useCallback(async (id) => {
        try {
            const isDCVPlay = localStorage.getItem("isDCVPlay");
            if (isDCVPlay) {
                localStorage.removeItem("isDCVPlay");
            }
            // const response = await API_GET(`https://core-api-dev.intraverse.com/core-api/web/vanity_links/${id}`);
            const response = id
                ? await API_GET(`${process.env.REACT_APP_CORE_API_URI}/web/vanity_links/${id}`)
                : { data: {} };
            const { roomId = "", staticUrl = process.env.REACT_APP_DEFAULT_STREAM_URL, clientTag } = response.data;

            localStorage.setItem("vanityLinkInfo", JSON.stringify({ roomId, clientTag }));
            // if (id === 'tz-casino') {
            //     const response = await RegisterUserWithLionGaming(email);
            //     if (response.status !== 200) {
            //         console.error('Error registering user with Lion Gaming:', response.data);
            //     }
            // }

            if (roomId !== "") {
                launchFlags["-roomid"] = roomId;
            } else {
                delete launchFlags["-roomid"];
            }
            if (clientTag !== "") {
                launchFlags["-clienttag"] = clientTag;
            }
            if (isRoomInvite && inviteSettings) {
                launchFlags["-roomid"] = isRoomInvite;
                launchFlags["-invitesettings"] = inviteSettings;
                const resp = await UpdateRoomInviteUserData(isRoomInvite, props.userId, inviteSettings, "login");
                if (resp.status === 200) {
                    localStorage.removeItem("inviteRoomId");
                    localStorage.removeItem("inviteSettings");
                }
            }

            const queryString = Object.entries(launchFlags)
                .map(([key, value]) => `${key}%20${value}`)
                .join("%20");
            const redirectURL = `${staticUrl}?launchFlags=${queryString}`;
            setRedirectURL(redirectURL);
        } catch (error) {
            if (process.env.REACT_APP_REDIRECT_TOGGLE) {
                window.location.replace("https://intraverse.com/");
            }
            console.error("Error fetching the vanity link:", error);
        }
    }, []);

    useEffect(() => {
        fetchVanityLink(resolvedPathId);
    }, [resolvedPathId, fetchVanityLink]);

    return redirectURL && <VagonStreamIntraverse streamUrl={redirectURL} spotifyPlayer={props?.spotifyPlayer} />;
};

export default VanityURLRedirects;

VanityURLRedirects.propTypes = {
    spotifyPlayer: PropTypes.object,
    userId: PropTypes.string,
    token: PropTypes.string,
    finalAvatar: PropTypes.string,
};
